import { useEffect, useRef } from "react";

export function useReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    if (typeof IntersectionObserver === "undefined") {
      node.classList.add("is-visible");
      return;
    }

    let observer;
    const start = () => {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
      );
      observer.observe(node);
    };

    if ("requestIdleCallback" in window) {
      const idleId = requestIdleCallback(start, { timeout: 2000 });
      return () => {
        cancelIdleCallback(idleId);
        observer?.disconnect();
      };
    }

    const timerId = window.setTimeout(start, 0);
    return () => {
      window.clearTimeout(timerId);
      observer?.disconnect();
    };
  }, []);

  return ref;
}
